module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "flex-grid flex-grid--wrap a-form-inputs",
    on: {
      "change": _vm.updateValid
    }
  }, [_c('form', {
    staticClass: "m-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('control', {
    attrs: {
      "for": "discount_rate",
      "label": "Discount Rate"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discountRate),
      expression: "discountRate"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "name": "discount_rate",
      "id": "discount_rate",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discountRate = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": -2.0
    }
  }, [_vm._v("-2.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -1.5
    }
  }, [_vm._v("-1.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -1.0
    }
  }, [_vm._v("-1.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.75
    }
  }, [_vm._v("-0.75%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.5
    }
  }, [_vm._v("-0.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": -0.25
    }
  }, [_vm._v("-0.25%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0.0
    }
  }, [_vm._v("0.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0.5
    }
  }, [_vm._v("0.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1.0
    }
  }, [_vm._v("1.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1.5
    }
  }, [_vm._v("1.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2.0
    }
  }, [_vm._v("2.00%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2.5
    }
  }, [_vm._v("2.50%")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3.0
    }
  }, [_vm._v("3.00%")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('discount_rate')
    }
  }, [_vm._v("\n                        Discount rate is required\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "name": "description_of_services",
      "label": "Description of Service"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service.descriptionOfService),
      expression: "service.descriptionOfService"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "autocomplete": "off",
      "name": "description_of_services",
      "maxlength": "100",
      "id": "description_of_services",
      "type": "text"
    },
    domProps: {
      "value": (_vm.service.descriptionOfService)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.service, "descriptionOfService", $event.target.value)
      }, _vm.update]
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "multiplicand",
      "label": "Multiplicand",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.service.multiplicand),
      expression: "service.multiplicand",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "required": "",
      "name": "multiplicand"
    },
    domProps: {
      "value": (_vm.service.multiplicand)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.service, "multiplicand", _vm._n($event.target.value))
      }, _vm.update],
      "blur": [function($event) {
        _vm.service.multiplicand = _vm.service.multiplicand || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('multiplicand')
    }
  }, [_vm._v("\n                        The multiplicand is required\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "duration_type",
      "label": "Dependency for life"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.durationMask),
      expression: "durationMask"
    }],
    attrs: {
      "name": "duration_type",
      "id": "duration_type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.durationMask = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])]), _vm._v(" "), (!_vm.durationMask) ? _c('control', {
    attrs: {
      "label": "Duration of Dependency",
      "for": "method1"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service.durationType),
      expression: "service.durationType"
    }],
    attrs: {
      "id": "method1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.service, "durationType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.update]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "years_and_months"
    }
  }, [_vm._v("Enter Years/Months")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "age"
    }
  }, [_vm._v("Enter Age at End of Dependency")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "date"
    }
  }, [_vm._v("Enter Date")])])]) : _vm._e(), _vm._v(" "), (_vm.service.durationType == 'years_and_months') ? _c('control', {
    attrs: {
      "label": "Enter Years/Months From the Start of Dependency"
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--half"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.service.years),
      expression: "service.years",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "id": "years"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.service, "years", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.update]
    }
  }, _vm._l((51), function(year) {
    return _c('option', {
      domProps: {
        "value": year - 1
      }
    }, [_vm._v(_vm._s(year - 1) + " year(s)")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.service.months),
      expression: "service.months",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "id": "months"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.service, "months", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.update]
    }
  }, _vm._l((12), function(month) {
    return _c('option', {
      domProps: {
        "value": month - 1
      }
    }, [_vm._v("\n                                    " + _vm._s(month - 1) + " month(s)\n                                ")])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.service.durationType == 'age') ? _c('control', {
    attrs: {
      "label": "Age at end of Dependency",
      "for": "age_at_end",
      "before-after": "years-old"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.service.age),
      expression: "service.age",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "required": "",
      "min": "20",
      "name": "age_at_end",
      "type": "number"
    },
    domProps: {
      "value": (_vm.service.age)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.service, "age", _vm._n($event.target.value))
      }, _vm.update],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "for": "services_end_of_dependency",
      "label": "End of Dependency"
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--half a-form-inputs--half-to"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:services_end_of_dependency.required",
      value: ({
        type: 'date',
        rules: _vm.servicesEndOfDependencyRules
      }),
      expression: "{type:'date', rules:servicesEndOfDependencyRules}",
      arg: "services_end_of_dependency",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "disabled": _vm.service.durationType != 'date'
    },
    on: {
      "input": _vm.update
    },
    model: {
      value: (_vm.service.toDate),
      callback: function($$v) {
        _vm.$set(_vm.service, "toDate", $$v)
      },
      expression: "service.toDate"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('services_end_of_dependency')
    }
  }, [_vm._v("\n                                End of Dependency is required, must be in the format DD/MM/YYYY, cannot be after the\n                                Deceased's End of Dependency (" + _vm._s(_vm.theDeceased.lifeExpectancy.dateOfDeath) + ")\n                                nor before the Deceased's Date of Death (" + _vm._s(_vm.theDeceased.dateOfDeath) + ")\n                            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__to"
  }, [_vm._v("for")]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container a-form-inputs--years"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service.duration),
      expression: "service.duration"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "field-control",
      rawName: "v-field-control:duration.required",
      value: ({
        type: 'number'
      }),
      expression: "{type:'number'}",
      arg: "duration",
      modifiers: {
        "required": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "disabled": _vm.service.durationType == 'life',
      "name": "duration",
      "min": "0"
    },
    domProps: {
      "value": (_vm.service.duration)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.service, "duration", $event.target.value)
      }, _vm.update]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('duration')
    }
  }, [_vm._v("\n                                Length of Dependency is required and must be at least one year\n                            ")])], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('control', {
    attrs: {
      "label": "Select Ogden Table"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discountTable),
      expression: "discountTable"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discountTable = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Table 1 or 2")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 28
    }
  }, [_vm._v("Table 36")])])]), _vm._v(" "), (_vm.service.discountTable === 1) ? _c('control', {
    attrs: {
      "label": _vm.table1Or2Label,
      "for": "ogden_table_multiplier"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "readonly": "",
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.dependencyOnIncome.table1Or2Multiplier
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.service.discountTable === 28) ? _c('control', {
    attrs: {
      "label": "Ogden Table 36 Multiplier",
      "for": "ogden_table_multiplier"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "readonly": "",
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.service.ogdenTableTwentyEight
    }
  })]) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "for": "ogden_table_e_pre_assessment",
      "label": "Ogden Table E Pre-Assessment Discount",
      "tip-icon": 'formula',
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": "ogden_table_e_pre_assessment",
      "modal-name": 'services_' + _vm.uniqueId,
      "endpoint": 'pre',
      "payload": _vm.preAndPostAssessmentPayload
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "id": "ogden_table_e_pre_assessment",
      "name": "ogden_table_e_pre_assessment",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.service.ogdenTableE
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "ogden_table_f_pre_assessment",
      "label": "Ogden Table F Post-Assessment Discount",
      "tip-icon": 'formula',
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": "ogden_table_f_pre_assessment",
      "modal-name": 'services_' + _vm.uniqueId,
      "endpoint": 'post',
      "payload": _vm.preAndPostAssessmentPayload
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "id": "ogden_table_f_pre_assessment",
      "name": "ogden_table_f_pre_assessment",
      "disabled": ""
    },
    domProps: {
      "value": _vm.service.ogdenTableF
    }
  })]), _vm._v(" "), _c('div', {
    class: {
      'a-loader--total': _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('control', {
    attrs: {
      "for": "calculated_services",
      "label": "Calculated Services",
      "before-after": "pound"
    }
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "min": "0.00",
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.currencyFormat(_vm.calculatedServices, '')
    }
  })]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-8"
  }, [_c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.deleteThisService
    }
  }, [_vm._v("Delete Service")]), _vm._v(" "), _c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.addService
    }
  }, [_vm._v("Add Service")])])]), _vm._v(" "), _c('div', {
    staticClass: "a-table--really-wide"
  }, [_c('div', {
    class: {
      'a-loader--table': _vm.servicesTableUpdating()
    }
  }), _vm._v(" "), (_vm.table && _vm.table.pre && _vm.table.post && !_vm.servicesTableUpdating()) ? _c('table', {
    staticClass: "a-table a-table--full-width",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Pre-Assessment period")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.table.pre.multiplier, 3)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.table.pre.multiplicand)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.table.pre.multiplier, 3)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.table.pre.discount, 3)))]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(_vm.roundValue(_vm.table.pre.discount, 3)) + " x " + _vm._s(_vm.roundValue(_vm.table.pre.duration, 3)) + " =\n                    " + _vm._s(_vm.roundValue(_vm.table.pre.discount * _vm.table.pre.multiplier, 3)) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.table.pre.dependencyValue)))])]), _vm._v(" "), (_vm.table.post.multiplier > 0) ? _c('tr', [_c('td', [_vm._v("Post-Assessment period")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.table.post.duration, 3)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.table.post.multiplicand)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.table.post.multiplier, 3)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.table.post.discount, 3)))]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(_vm.roundValue(_vm.table.post.discount, 3)) + " x " + _vm._s(_vm.roundValue(_vm.table.post.multiplier, 3)) + " =\n                    " + _vm._s(_vm.roundValue(_vm.table.post.discount * _vm.table.post.multiplier, 3)) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.table.post.dependencyValue)))])]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'services_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Period")]), _vm._v(" "), _c('th', [_vm._v("Duration (years)")]), _vm._v(" "), _c('th', [_vm._v("Dependency Multiplicand")]), _vm._v(" "), _c('th', [_vm._v("Multiplier")]), _vm._v(" "), _c('th', [_vm._v("Discount Factor")]), _vm._v(" "), _c('th', [_vm._v("Discounted Multiplier")]), _vm._v(" "), _c('th', [_vm._v("Dependency Value")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6c545ed7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/fatal-accident-claims/dependency/steps/dependency-on-services/Service.vue
// module id = 1738
// module chunks = 0